import React from "react";

const ButtonPrimary = ({ children, ...args }) => {
  return (
    <button
      className="btn btn-lg custom-primary "
      type="button"
      style={{ color: "#ffffff", padding: "5px, 10px" }}
      {...args}
    >
      {children}
    </button>
  );
};

export default ButtonPrimary;
